export let ID = +new Date();

export function getNumericId() {
  return ID++;
}
